import HeroSlider from './components/HeroSlider';
import CategoryNav from './components/CategoryNav';
import HotRecommend from './components/HotRecommend';
import LatestUpdates from './components/LatestUpdates';
import FaqSection from './components/FaqSection';
import SchemaOrg, { organizationSchema, websiteSchema, buildBreadcrumbSchema, buildFaqSchema } from '@/components/feature/SchemaOrg';
import { faqs } from '@/mocks/home';

export default function Home() {
  return (
    <>
      <SchemaOrg type="Organization" data={organizationSchema} />
      <SchemaOrg type="WebSite" data={websiteSchema} />
      <SchemaOrg type="WebPage" data={{
        name: '凪光在线观看 - 首页',
        url: 'https://subtitlesjp.github.io/',
        breadcrumb: { '@type': 'BreadcrumbList', ...buildBreadcrumbSchema([{ name: '首页', url: '/' }]) },
      }} />
      <SchemaOrg type="BreadcrumbList" data={buildBreadcrumbSchema([{ name: '首页', url: '/' }])} />
      <SchemaOrg type="FAQPage" data={buildFaqSchema(faqs.map(f => ({ question: f.question, answer: f.answer })))} />
      <HeroSlider />
      <CategoryNav />
      <HotRecommend />
      <LatestUpdates />
      <FaqSection />
    </>
  );
}